import * as React from 'react';
import './fields.scss';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { useTranslations } from '../../../store/translations/hooks';
import { DayOfWeekEnum } from '../../../models';

export interface DayOfWeekFieldProps {
    id?: string,
    label?: string,
    value: DayOfWeekEnum,
    onChange: (value: DayOfWeekEnum) => void,
}

export const DayOfWeekField = (props: DayOfWeekFieldProps) => {
    const {
        id,
        label,
        value,
        onChange,
    } = props;

    const t = useTranslations() as (key:string) => string;
    const parse = (sex: string) => DayOfWeekEnum[sex as keyof typeof DayOfWeekEnum];

    const labelId = label && id ? `${id}-label` : undefined;

    return (
        <FormControl fullWidth size="small" className="dayOfWeek">
            {label && <InputLabel id={labelId}>{label}</InputLabel>}
            <Select
                id={id ? `${id}-input` : undefined}
                labelId={labelId}
                value={DayOfWeekEnum[value]}
                label={label}
                onChange={e => onChange(parse(e.target.value))}
                variant="outlined"
            >
                {
                    Object.values(DayOfWeekEnum)
                        .filter(p => typeof p === 'string')
                        .map(p => p as string)
                        .map(k => (
                            <MenuItem
                                id={id ? `${id}-option-${k}` : undefined}
                                key={k}
                                value={k}
                            >
                                {t(`day${k}`)}
                            </MenuItem>
                        ))
                }
            </Select>
        </FormControl>
    );
}
